import * as React from 'react'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import CommonContext from '../CommonContext'
import FormFields from './FormFields'

export default function RangeEntriesApp(props: any) {
  const { dynamicsnavPrefix, currentUser, ...rest } = props
  const queryClient = buildQueryClient()
  return (
    <CommonContext.Provider value={{ dynamicsnavPrefix, currentUser }}>
      <QueryClientProvider client={queryClient}>
        <FormFields {...rest} />
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
